export default {
	STORE_LANDING: 'store-landing',
	SCHOOL_LIBRARY: 'school',
	DISTRICT_LIBRARY: 'district',
}
